/**
 * @generated SignedSource<<7969552d8b6b52af9f980e2c4883f38c>>
 * @lightSyntaxTransform
 * @nogrep
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { Fragment, ReaderFragment } from 'relay-runtime';
export type UserStatus = "active" | "activeEfnNeeded" | "changeInProgress" | "doccheck" | "doctorWithEfnInitialValidation" | "efnNeeded" | "inactive" | "initialValidation" | "noProcess" | "%future added value";
import { FragmentRefs } from "relay-runtime";
export type NavigateDirectToQuestionsAdvanceTreeButton_UserFragment$data = {
  readonly extension: {
    readonly globalUserStatus?: UserStatus;
  } | null;
  readonly " $fragmentType": "NavigateDirectToQuestionsAdvanceTreeButton_UserFragment";
};
export type NavigateDirectToQuestionsAdvanceTreeButton_UserFragment$key = {
  readonly " $data"?: NavigateDirectToQuestionsAdvanceTreeButton_UserFragment$data;
  readonly " $fragmentSpreads": FragmentRefs<"NavigateDirectToQuestionsAdvanceTreeButton_UserFragment">;
};

const node: ReaderFragment = {
  "argumentDefinitions": [],
  "kind": "Fragment",
  "metadata": null,
  "name": "NavigateDirectToQuestionsAdvanceTreeButton_UserFragment",
  "selections": [
    {
      "alias": null,
      "args": [
        {
          "kind": "Literal",
          "name": "userExtensionKind",
          "value": "InfectopharmUserExtension"
        }
      ],
      "concreteType": null,
      "kind": "LinkedField",
      "name": "extension",
      "plural": false,
      "selections": [
        {
          "kind": "InlineFragment",
          "selections": [
            {
              "alias": null,
              "args": null,
              "kind": "ScalarField",
              "name": "globalUserStatus",
              "storageKey": null
            }
          ],
          "type": "InfectopharmUserExtension",
          "abstractKey": null
        }
      ],
      "storageKey": "extension(userExtensionKind:\"InfectopharmUserExtension\")"
    }
  ],
  "type": "User",
  "abstractKey": null
};

(node as any).hash = "f992118d7da4054c0212c36522c6a45f";

export default node;
